import { Component } from '@angular/core'
import { MatHint } from '@angular/material/form-field'

@Component({
	selector: 'form-hint',
	template: ` <mat-hint><ng-content></ng-content></mat-hint> `,
	imports: [MatHint],
})
export class FormHintComponent {}
